import styles from './PageHero.module.css';

type PageHeroProps = {
  /** Background banner image. */
  readonly image: string;
  /** English label shown above the title (e.g. "COMPANY"). */
  readonly eyebrow: string;
  /** Japanese page title (e.g. "会社概要"). */
  readonly title: string;
};

export const PageHero = ({
  image,
  eyebrow,
  title,
}: PageHeroProps): JSX.Element => {
  return (
    <section className={styles.hero} aria-label={title}>
      <img className={styles.heroImage} src={image} alt="" />
      <div className={styles.heroContent}>
        <p className={styles.heroEyebrow}>{eyebrow}</p>
        <h1 className={styles.heroTitle}>{title}</h1>
      </div>
    </section>
  );
};
